/**
 * @file   千年琴史 内容页
 * @create macaiqi 2025/05/06
 * @update
 */
import React, { useEffect, useState } from 'react';
import cls from "classnames";
import SH from "./sh";
// import { useRoutesMap } from '@portal-site/core';
import "viewerjs/dist/viewer.min.css";

import { queryArchivesList, queryAllChannel } from '../../../service';

import "./qnqs.scss";

export default function QNQS({ setShow, show }) {
  const [showdata, setshowdata] = useState([]);

  const [tabactive, setTabActive] = useState("XQ_gs");
  const [listdata, setListData] = useState([])

  // let showdata = qnqsdata?.[show.split("-")[1]];

  useEffect(() => {
    queryAllChannel('QNQS').then(res => {
      let show1 = res?.records?.filter(a => {
        return a.channelNo === show.split("-")[1]
      })?.[0]
      setshowdata(show1)
      setTabActive(show1.subChannel[0]?.channelNo)
    })
  }, [show])

  useEffect(() => {
    setListData([])
    queryArchivesList({
      resource: tabactive,
      pagination: {
        size: 0,
        page: 0
      }
    }).then(res => {
      setListData(res?.records || [])
    })
  }, [tabactive])
  let topdes = showdata?.subChannel?.filter(a => { return a.channelNo === tabactive })?.[0]?.description
  return (
    <div className="common-page qnqscontent-page">
      <div className="page-l">
        <i />
        <div className="titleall">
          <div className="bigtxt" />
          <div className="title">{showdata?.channelName}</div>
        </div>

        <div
          className="back"
          onClick={() => {
            setShow("qnqshome");
          }}></div>
      </div>

      <div className="tablist">
        {showdata &&
          showdata?.subChannel?.map((item, index) => {
            return (
              <div
                className={cls("tab", { active: tabactive === item.channelNo })}
                key={index}
                onClick={() => {
                  setTabActive(item.channelNo);
                }}
              >{item.channelName}</div>
            );
          })}
      </div>
      {tabactive?.includes("gs") && (
        <div
          className={cls("content", `gscontent`)}
        >
          <div className="scorll">
            {listdata?.map((item) => {
              return (
                <div dangerouslySetInnerHTML={{ "__html": item?.content }} />
              )
            })}
          </div>

        </div>
      )}
      {(tabactive?.includes("qrqq") || tabactive?.includes("qp") || tabactive?.includes("ql") || tabactive?.includes("qs")) && (
        <div className={cls("content", `commoncontent qrqqcontent`, { 'qpcontent': tabactive?.includes("qp") })}>
          <div className="scroll">
            {topdes && (
              <div
                className="top"
                dangerouslySetInnerHTML={{ __html: topdes }}
              />
            )}
            {listdata?.map((item, index) => {
              return (
                <div className="item" key={index}>
                  <div className="contenttitle">
                    {item.title}
                    {item.time && <span className="sub">{item.subtitle}</span>}
                  </div>
                  <div className="f">
                    {item.imgSrc && <div className="imgbox">
                      <img src={window.ENV_IMG_PREURL + item.imgSrc} alt="" srcset="" />

                    </div>}
                    <div
                      className="des"
                      dangerouslySetInnerHTML={{ __html: item.content }}></div>
                  </div>

                </div>
              );
            })}
          </div>
        </div>
      )}
      {tabactive?.includes("sh") && <SH listdata={listdata} />}
      {tabactive?.includes("sc") && (
        <div className={cls("content", `sccontent`)}>
          <div className="scroll">
            {listdata?.map((item, index) => {
              return (
                <img src={window.ENV_IMG_PREURL + item.imgSrc} alt="" key={index} />
              )
            })}
          </div>

        </div >
      )
      }
    </div >
  );
}
